import BaseModal from 'app/views/modals/base_modal';

import tmpl from 'templates/payment_method_remove_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'click .confirm_remove': 'removePaymentMethod',
  },

  initialize(options) {
    this.priority = options.priority;
  },

  removePaymentMethod(event) {
    event.preventDefault();
    const self = this;
    this.model.destroy({
      success() {
        self.collection.unset(`${self.priority}_payment_method`);
      },
    });
    this.close();
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/payment_method_remove_modal.js